import { BLOG_CONTROL_D_DOMAIN, DOCS_CONTROL_D_DOMAIN } from 'gatsby-env-variables'
import { noRedirectHomePagePath } from 'layouts'

export interface FooterLink {
  text: string
  to: string
  isExternal?: boolean
}

export interface FooterAction {
  title: string
  to: string
}

export interface FooterSection {
  title: string
  links: FooterLink[]
  actions?: FooterAction[]
}

export interface FooterLinks {
  general: FooterSection
  features: FooterSection
  industries: FooterSection
  resources: FooterSection
}

const general = [
  {
    text: 'About Us',
    to: '/about-us',
  },
  {
    text: 'Pricing',
    to: '/pricing',
  },
  {
    text: 'Personal Use',
    to: `/personal${noRedirectHomePagePath}`,
  },
  {
    text: 'Free DNS',
    to: '/free-dns',
  },
  {
    text: 'Help',
    to: '/',
    isExternal: true,
  },
  {
    text: 'Privacy',
    to: 'https://controld.com/privacy',
  },
  {
    text: 'Terms',
    to: 'https://controld.com/terms',
  },
]

const features = [
  {
    text: 'Malware Blocking',
    to: '/features/malware-blocking',
  },
  {
    text: 'Web Filtering',
    to: '/features/web-filtering',
  },
  {
    text: 'Service Filtering',
    to: '/features/service-filtering',
  },
  {
    text: 'Custom Filtering',
    to: '/features/custom-filtering',
  },
  {
    text: 'Modern Protocols',
    to: '/features/modern-protocols',
  },
  {
    text: 'Analytics',
    to: '/features/analytics',
  },
  {
    text: 'Data Streaming (SIEM)',
    to: '/features/data-streaming-siem',
  },
  {
    text: 'Traffic Redirection',
    to: '/features/traffic-redirection',
  },
  {
    text: 'Multi-Tenancy',
    to: '/features/multi-tenancy',
  },
  {
    text: 'Admin Logs',
    to: '/features/admin-logs',
  },
  {
    text: 'Integrations',
    to: '/features/integrations',
  },
]

const industries = [
  {
    text: 'Start-Ups',
    to: '/industry-startups',
    isExternal: true,
  },
  {
    text: 'Small Businesses',
    to: '/industry-smbs',
    isExternal: true,
  },
  {
    text: 'Public Wi-Fi',
    to: '/industry-public-wifi',
    isExternal: true,
  },
  {
    text: 'Education',
    to: '/content-filtering-schools',
  },
  {
    text: 'Hospitality',
    to: '/industry-airbnb-hosts',
    isExternal: true,
  },
  {
    text: 'MSPs',
    to: '/industry-msps',
    isExternal: true,
  },
  {
    text: 'Non-Profits',
    to: '/industry-non-profits',
    isExternal: true,
  },
]

const resources = [
  {
    text: 'Knowledge Base',
    to: '/',
    isExternal: true,
  },
  {
    text: 'API Docs',
    to: `${DOCS_CONTROL_D_DOMAIN}/reference`,
    isExternal: true,
  },
  {
    text: 'Blog',
    to: `${BLOG_CONTROL_D_DOMAIN}`,
    isExternal: true,
  },
  {
    text: 'Network',
    to: '/network',
  },
  {
    text: 'Changelog',
    to: `${DOCS_CONTROL_D_DOMAIN}/changelog`,
  },
  {
    text: 'Status',
    to: '/status',
  },
  {
    text: 'Support',
    to: '/contact',
  },
]

export const footerLinks: FooterLinks = {
  general: {
    title: 'General',
    links: general,
    actions: [
      {
        title: 'Log in',
        to: '/login',
      },
      {
        title: 'Sign Up',
        to: '/onboard',
      },
      {
        title: 'Go to Dashboard',
        to: '/dashboard',
      },
    ],
  },
  features: {
    title: 'Features',
    links: features,
  },
  industries: {
    title: 'Industries',
    links: industries,
  },
  resources: {
    title: 'Resources',
    links: resources,
  },
}
